import React from 'react';

import { s } from '@functions/seo.ts';

import I from '../types.ts';

const renderCompanies: I['renderCompanies'] = function () {
    return (
        <div className="publicExecutorsHeader__companies _col">
            <div className="publicExecutorsHeader__companiesTitle">
                Заказы от <span>лучших компаний</span> на рынке:
            </div>
            <div className="publicExecutorsHeader__companiesItems _row">
                {this.companies.map((company) => (
                    <div className="publicExecutorsHeader__companiesItem" key={company}>
                        {!s() && (
                            <img
                                src={require(`@img/crm/public/${company}`)}
                                alt=""
                                className="publicExecutorsHeader__companiesItemLogo"
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default renderCompanies;
